import { useTranslation } from 'react-i18next';

import { CreativePreview } from '@features/campaigns/builder/components/CreativePreview/CreativePreview.tsx';
import { CREATIVE_CATEGORY, CREATIVE_TYPE } from '@features/campaigns/builder/types/creativeType.ts';
import { i18nNameSpace } from '@shared/consts/i18n.ts';

interface AdProductsLShapeLandingCreativesProps {
  lShapeImageUrl?: string | null;
  landingImageUrl?: string | null;
}

export function AdProductsLShapeLandingCreatives({
  lShapeImageUrl,
  landingImageUrl,
}: AdProductsLShapeLandingCreativesProps) {
  const { t } = useTranslation(i18nNameSpace.CAMPAIGNS);

  return (
    <>
      {lShapeImageUrl && (
        <div className={'col-6'}>
          <CreativePreview
            creativeUrl={lShapeImageUrl}
            creativeType={CREATIVE_TYPE.LSHAPE}
            creativeCategory={CREATIVE_CATEGORY.IMAGE}
            fileName={'review.creatives.lShapeImage'}
            headerText={t('builder.formFields.creativeLShapeImage.modalHeaderText')}
          />
        </div>
      )}
      {landingImageUrl && (
        <div className={'col-6'}>
          <CreativePreview
            creativeUrl={landingImageUrl}
            creativeType={CREATIVE_TYPE.LANDING}
            creativeCategory={CREATIVE_CATEGORY.IMAGE}
            fileName={'review.creatives.landingImage'}
            headerText={t('builder.formFields.creativeLandingImage.modalHeaderText')}
          />
        </div>
      )}
    </>
  );
}
